<template>
  <div
    id="MyReviewHeader"
    :key="productDetails.pr_page_id"
    class="power-reviews container mb-6"
    :data-powerreviews="productDetails.pr_page_id"
  >
    <pdl-loading :is-loading="!isReviewsComponentRendered" />

    <div :id="`pr-imagesnippet-${productDetails.pr_page_id}`" class="pr-imagesnippet"></div>
    <div :id="`pr-reviewdisplay-${productDetails.pr_page_id}`" class="pr-reviewdisplay"></div>
    <div id="questions-wrapper">
      <div :id="`pr-questiondisplay-${productDetails.pr_page_id}`" class="pr-questiondisplay"></div>
    </div>
  </div>
</template>
<script>
import {PdlLoading} from '@pedal/pdl-loading';
import {mapState} from 'vuex';

export default {
  name: 'ProductReviewsComponent',
  components: {
    PdlLoading,
  },
  data() {
    return {
      isReviewsComponentRendered: false,
    };
  },
  computed: {
    ...mapState('powerReviews', ['productDetails', 'isWindowPwrLoaded']),
    ...mapState('backend', [
      'powerReviewsLocale',
      'powerReviewsMerchantGroupId',
      'powerReviewsMerchantId',
      'powerReviewsApiKey',
    ]),
  },
  watch: {
    isWindowPwrLoaded(val) {
      if (val && this.productDetails.pr_page_id) {
        this.initPowerReviews();
      }
    },
    productDetails(val) {
      if (val.pr_page_id && this.isWindowPwrLoaded) {
        this.isReviewsComponentRendered = false;
        this.$nextTick(() => {
          this.initPowerReviews();
        });
      }
    },
  },
  mounted() {
    if (this.isWindowPwrLoaded && this.productDetails.pr_page_id) {
      this.initPowerReviews();
    }
  },
  methods: {
    initPowerReviews() {
      if (window.pwr && !this.isReviewsComponentRendered) {
        let powerReview = {
          locale: this.powerReviewsLocale,
          merchant_group_id: this.powerReviewsMerchantGroupId,
          page_id: this.productDetails.pr_page_id,
          merchant_id: this.powerReviewsMerchantId,
          api_key: this.powerReviewsApiKey,
          review_wrapper_url: this.productDetails.pr_write_review,
          on_render: () => {
            let reviewsQaHeaderElement = document.querySelector('[title="Questions & Answers"]');
            if (reviewsQaHeaderElement) {
              reviewsQaHeaderElement.innerText = this.$t('product.details.nav.label.faqs');
            }
            let reviewsCountElement = document.getElementsByClassName('pr-snippet-review-count');
            let scrollToReviews = () => {
              let reviewHeaderElement = document.getElementById('MyReviewHeader');
              reviewHeaderElement.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'});
            };
            if (reviewsCountElement[0]) {
              reviewsCountElement[0].addEventListener('click', scrollToReviews);
            }
          },
          components: {
            ReviewImageSnippet: `pr-imagesnippet-${this.productDetails.pr_page_id}`,
            ReviewDisplay: `pr-reviewdisplay-${this.productDetails.pr_page_id}`,
            QuestionDisplay: `pr-questiondisplay-${this.productDetails.pr_page_id}`,
          },
          product: {
            name: this.productDetails.pr_product_name,
            url: this.productDetails.pr_product_url,
            image_url: this.productDetails.pr_product_image,
            description: this.productDetails.pr_product_description,
            category_name: this.productDetails.pr_product_category_name,
            manufacturer_id: this.productDetails.pr_product_manufacturer_id,
            upc: this.productDetails.pr_product_upc,
            brand_name: this.productDetails.pr_product_brand_name,
            price: this.productDetails.pr_product_price,
            in_stock: this.productDetails.pr_product_in_stock,
          },
        };

        if (powerReview) {
          window.pwr('render', powerReview);
          this.isReviewsComponentRendered = true;
        }
      }
    },
  },
};
</script>
